import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";
import { send as sendAlert } from "./alert";


export const get = ({ staffUuid, personUuid, caseUuid, uuid, startDate, endDate }) => async (dispatch) => {
    try {
        let modifications = "";
        const pivot = isGuid(staffUuid) ? "/staff" : isGuid(personUuid) ? "/person" : isGuid(caseUuid) ? "/case" : "";
        const finalUuid = isGuid(staffUuid) ? staffUuid : isGuid(personUuid) ? personUuid : isGuid(caseUuid) ? caseUuid : uuid;
        if (startDate && endDate) modifications += `/r/${startDate}/${endDate}`;

        const res = await api.get(`/staff/clocks${pivot}/i/${finalUuid}${modifications}`);
        
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
}

export const save = ({ uuid,
    caseUuid,
    personUuid,
    staffUuid,
    started,
    ended,
    minutes,
    rate,
    gross,
    writeOff,
    net,
    notes }) => async (dispatch) => {
        try {
            const res = await api.post(`/staff/clocks`, {
                uuid,
                caseUuid,
                personUuid,
                staffUuid,
                started,
                ended,
                minutes,
                rate,
                gross,
                writeOff,
                net,
                notes
            });
            if (res.data?.success && res.data?.posting?.success === false) {
                dispatch(sendAlert(res.data.posting.error?.message || "Billable time was saved but could not be posted to accounting.", "warning"));
            }
            return res.data;
        } catch (error) {
            if (error?.response?.status === 401) dispatch({ type: LOGOUT });

            const payload = error?.response?.data?.error || error;
            const message = payload?.message || "Unable to save billable time.";
            dispatch(sendAlert(message, "error"));

            return { success: false, error: payload };
        }
    }
